export function BackstageHeader({ title }: { title?: string }) {
  return (
    <div
      className={
        "min-h-[50px] h-[50px] border-b flex items-center justify-center border-[#EBEDF2] w-full bg-white"
      }
    >
      <h1 className={"font-semibold text-lg"}>{title || ""}</h1>
    </div>
  );
}
